import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { allMedia } from "@/utils/media";

const tintMap: Record<string, string> = {
  primary: "bg-primary-50 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50",
  accent: "bg-accent-50 text-accent-700 group-hover:bg-accent-500 group-hover:text-primary-950",
  secondary: "bg-secondary-100 text-secondary-700 group-hover:bg-secondary-600 group-hover:text-background-50",
};

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
      {categories.map((cat) => {
        const count = allMedia.filter((item) => item.type === cat.slug).length;
        return (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center rounded-lg bg-background-50 p-5 text-center ring-1 ring-background-200 transition duration-300 hover:-translate-y-1 hover:ring-primary-300"
          >
            <span
              className={`flex h-14 w-14 items-center justify-center rounded-lg text-2xl transition-colors ${tintMap[cat.tint]}`}
            >
              <i className={cat.icon} />
            </span>
            <span className="mt-3 font-heading text-sm font-bold text-foreground-900">{cat.name}</span>
            <span className="mt-0.5 text-xs text-foreground-500">{count} 部作品</span>
          </Link>
        );
      })}
    </div>
  );
}